var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-nav"},[_c('nav',{staticClass:"content-wap"},[_c('div',{staticClass:"content"},[_c('tab-bar'),_c('search-box')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }